"use strict";
module.exports = require("./arangojs").default;
module.exports.default = module.exports;
Object.defineProperty(module.exports, "__esModule", { value: true });



// WEBPACK FOOTER //
// ./src/index.js